import React from 'react';
import { ArcCollapse, ArcStack, ArcStatusPoint, ArcText } from '@src/core/ui';
import { ReactComponent as ArrowUpIcon } from '@src/assets/icons/arrow-up.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectCollapse, toggleCollapse } from '@src/features/zones/redux';
import { ToggleCollapseViewProps } from './types';
import { ZoneTypeColor, ZoneTypeName } from '@src/features/zones/config/zones-constants';

const ToggleCollapseView: React.FC<ToggleCollapseViewProps> = (props) => {
  const { zoneType, children, count = 0 } = props;

  const dispatch = useDispatch();
  const collapse = useSelector(selectCollapse);

  const isDisabled = count < 1;
  const isOpen = collapse[zoneType];
  
  const onToggleCollapse = () => {
    dispatch(toggleCollapse(zoneType));
  };

  const onClick = () => {
    if (isDisabled) {
      return;
    }
    onToggleCollapse();
  };

  const renderIcon = () => {
    if (isDisabled) {
      return null;
    }

    return (
      <ArrowUpIcon width={18} style={{
        transform: `rotate(${isOpen ? '0deg' : '180deg'})`,
        transition: 'transform 0.3s',
      }}  />
    );
  };

  return (
    <ArcStack>
      <ArcStack 
        spacing={1} 
        direction='row' 
        alignItems='center'
        justifyContent='space-between'
        sx={{ cursor: 'pointer' }}
        onClick={onClick}>

        <ArcStack 
          spacing={1} 
          direction='row' 
          alignItems='center'>
          <ArcStatusPoint.s bgcolor={ZoneTypeColor[zoneType]} />
          <ArcText.h5 
            color={isDisabled ? 'text.secondary' : 'text.primary'}> 
            {ZoneTypeName[zoneType]} ({count})
          </ArcText.h5>
        </ArcStack>

        {renderIcon()}
      </ArcStack>

      <ArcCollapse in={isOpen} timeout="auto" unmountOnExit={false}>
        {children}
      </ArcCollapse>
    </ArcStack>
  );
};

export default ToggleCollapseView;
